(function () {
  function playVideo(video) {
    if (!video) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (error) {}
  }

  function bindHoverVideo(card, video) {
    if (!video || video.dataset.technicalBound === 'true') return;
    video.dataset.technicalBound = 'true';

    var playHover = function () {
      playVideo(video);
    };
    var pauseHover = function () {
      pauseVideo(video);
    };

    card.addEventListener('mouseenter', playHover);
    card.addEventListener('mouseleave', pauseHover);
    card.addEventListener('focusin', playHover);
    card.addEventListener('focusout', function () {
      if (!card.contains(document.activeElement)) pauseHover();
    });
  }

  function bindSlideVideo(video) {
    if (!video || video.dataset.technicalBound === 'true') return;
    video.dataset.technicalBound = 'true';
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { threshold: [0, 0.6, 1] }
    );
    observer.observe(video);
  }

  function bindCard(card) {
    if (!card) return;
    bindHoverVideo(card, card.querySelector('.product-card__hover-video'));
    bindSlideVideo(card.querySelector('.product-card__slide-video'));
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('[data-has-technical-video]');
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
    if (scope !== document && scope.hasAttribute && scope.hasAttribute('data-has-technical-video')) {
      bindCard(scope);
    }

    var hoverVideos = scope.querySelectorAll('.product-card__hover-video, .product-card__slide-video');
    for (var j = 0; j < hoverVideos.length; j++) {
      var videoCard = hoverVideos[j].closest('.product-card-wrapper');
      if (videoCard) bindCard(videoCard);
    }
  }

  window.HuhaTechnicalVideo = { init: init };

  function observeNewCards() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.hasAttribute && node.hasAttribute('data-has-technical-video')) {
            bindCard(node);
          }
          if (node.classList && (node.classList.contains('product-card__hover-video') || node.classList.contains('product-card__slide-video'))) {
            bindCard(node.closest('.product-card-wrapper'));
          }
          if (node.querySelectorAll) {
            var nestedCards = node.querySelectorAll('[data-has-technical-video]');
            for (var k = 0; k < nestedCards.length; k++) bindCard(nestedCards[k]);
            var nestedVideos = node.querySelectorAll('.product-card__hover-video, .product-card__slide-video');
            for (var n = 0; n < nestedVideos.length; n++) {
              bindCard(nestedVideos[n].closest('.product-card-wrapper'));
            }
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function start() {
    init(document);
    observeNewCards();
    document.addEventListener('facets:update', function () {
      init(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
